enum InsuranceProductCategory {
  ACCIDENT = 'ACCIDENT',
  ACCIDENT_COMBINED = 'ACCIDENT_COMBINED',
  ACCIDENT_INSURANCE = 'ACCIDENT_INSURANCE',
  BUILDING_UNDER_CONSTRUCTION = 'BUILDING_UNDER_CONSTRUCTION',
  CAR = 'CAR',
  CHILD = 'CHILD',
  CRITICAL_DISEASE = 'CRITICAL_DISEASE',
  DEBT_INSURANCE = 'DEBT_INSURANCE',
  DISABILITY_CAPITAL = 'DISABILITY_CAPITAL',
  DISABILITY_CAPITAL_WITH_CHILD = 'DISABILITY_CAPITAL_WITH_CHILD',
  DISABILITY_PENSION = 'DISABILITY_PENSION',
  DISABILITY_PENSION_WITH_CHILD = 'DISABILITY_PENSION_WITH_CHILD',
  DOG_AND_CAT = 'DOG_AND_CAT',
  HORSE = 'HORSE',
  HOUSE = 'HOUSE',
  HOUSEHOLD_CONTENT = 'HOUSEHOLD_CONTENT',
  LEISURE_BOAT = 'LEISURE_BOAT',
  LEISURE_HOME = 'LEISURE_HOME',
  LIFE = 'LIFE',
  MOPED = 'MOPED',
  MOTORBIKE = 'MOTORBIKE',
  SNOW_SCOOTER = 'SNOW_SCOOTER',
  TRACTOR = 'TRACTOR',
  TRAILER_OR_CARAVAN = 'TRAILER_OR_CARAVAN',
  TRAVEL = 'TRAVEL',
  TREATMENT = 'TREATMENT',
  VALUABLES = 'VALUABLES',
  VETERAN_CAR = 'VETERAN_CAR',
}

export default InsuranceProductCategory;
